import axios from 'axios';
import { API_URL } from 'projectConfig';
import { getAccessToken } from 'auth';
import CurrentUser from 'auth/currentUser';
import { get } from 'lodash';

export default async function GetTransactionScoreReport(transactionId: string, filename: string) {
  if (!transactionId) {
    return;
  }
  const token = await getAccessToken();
  const accessToken = token?.accessToken || '';
  const selected_locale = CurrentUser.getInstance().getLocale();
  if (!accessToken) {
    return;
  }
  const url = `${API_URL}/api/Transaction/Score/${transactionId}?output=Pdf&currentLocale=${selected_locale}`;
  const response = await axios({
    url,
    method: 'GET',
    headers: { Authorization: 'Bearer ' + accessToken },
    responseType: 'blob',
  });
  if (response.status === 200) {
    const blob = new Blob([response.data]);
    console.log(blob);
    const msSaveBlob = get(navigator, 'msSaveBlob') as
      | ((blob: Blob, filename: string) => void)
      | undefined;
    if (msSaveBlob) {
      msSaveBlob(blob, filename);
    } else {
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      link.click();
    }
  } else {
    const message = `Download failed: ${response.statusText}`;
    console.error(message);
  }
}
